import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeOp } from 'src/app/util/animations.util';

@Component({
  selector: 'app-check-email',
  templateUrl: './check-email.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    './check-email.component.css'
  ],
  animations: [
    fadeOp
  ]
})
export class CheckEmailComponent implements OnInit {
  email: string='your-eamil@gmail.com';
  constructor(
    private user: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService
  ) {
    this.email= this.route.snapshot.params.value;
  }

  ngOnInit(): void {
    if (!this.user.user || !this.user.user.email){
      this.router.navigateByUrl('/auth/login')
    }
  }
  changeLang(lang: string): void {
    this.utility.changeLang(lang)
  }

  get availableLangs(): string[] {
    return this.utility.getAvailableLang();
  }

  get currentLang(): string {
    return this.utility.getLang();
  }
  resendVerifyMail(): void {
    this.user.resendVerifyEmail(this.user.user.email).subscribe();
  }
}
